// Direction B Orbit: 24 discrete hard-color ticks slowly rotating around a
// dashed guide ring. Used purely as decorative homepage hero art now — it
// reads great as a brand mascot but was too large/loud to be the everyday
// functional record control (see client/record-control.ts for that).

/** Builds and positions the 24 ticks inside a `.orbit-ticks` container.
 * Radius is computed from the rendered size (the ring is responsive), so
 * this must be called once mounted and again on resize. */
export function mountDecorativeOrbit(root: HTMLElement): void {
  const ticksEl = root.querySelector('.orbit-ticks') as HTMLElement;
  if (!ticksEl) return;
  for (let i = 0; i < 24; i++) {
    const tick = document.createElement('i');
    tick.className = 'tick';
    ticksEl.appendChild(tick);
  }
  const position = () => {
    // 0.45 put a tick's outer edge (radius + half its own 24px length)
    // almost exactly at the container's own boundary -- on the landing
    // page, where this ring sits close to the headline/lede at narrow
    // viewports, that was enough to visibly overlap the text as the ring
    // rotates. 0.40 pulls ticks inward enough to clear it reliably.
    const radius = Math.max(1, Math.round(ticksEl.getBoundingClientRect().width * 0.4));
    const children = ticksEl.children;
    for (let i = 0; i < children.length; i++) {
      (children[i] as HTMLElement).style.transform =
        `translate(-50%, -50%) rotate(${i * 15}deg) translateY(-${radius}px)`;
    }
  };
  position();
  window.addEventListener('resize', position);
}

export function fmtClock(totalSeconds: number): string {
  const s = Math.max(0, Math.floor(totalSeconds));
  const m = Math.floor(s / 60);
  const sec = s % 60;
  return `${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
}
